<template>
  <Loader :loading="httpSend">
    <div class="row mb-2">
      <div class="col-md-12 text-right">
        <b-button :disabled="!!tabeliao.tps_razao_social_nome" v-b-modal.modal-new-tabeliao variant="dark">Incluir Tabelião</b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h6 v-show="!tabeliao.tps_razao_social_nome" class="text-danger">Necessário informar o tabelião</h6>
        <div v-show="tabeliao.tps_razao_social_nome" class="table-responsive">
          <table class="table mb-0">
            <thead>
            <tr>
              <th>Nome</th>
              <th>CPF</th>
              <th>Telefone</th>
              <th>E-mail</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ tabeliao.tps_razao_social_nome }}</td>
              <td>{{ tabeliao.tps_cpf_cnpj | VMask('###.###.###-##')}}</td>
              <td>{{ tabeliao.tet_codigo_comercial | VMask('(##) #### - ####?#')}}</td>
              <td>{{ tabeliao.tps_mail }}</td>
              <td class="text-right">
                <button type="button" title="Editar" @click="openTabeliao(tabeliao)"
                        class="btn btn-outline-info btn-sm mr-2">
                  <i class="bx bxs-edit"></i></button>
                <button type="button" title="Excluir" @click="deleteTabeliao(tabeliao)"
                        class="btn btn-outline-danger btn-sm">
                  <i class="bx bxs-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal
        id="modal-new-tabeliao"
        ref="modal-new-tabeliao"
        size="xl"
        title="Cadastrar Tabelião"
        title-class="font-18"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true">
      <div class="modal-body">
        <Loader :loading="httpSend">
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="CPF" label-for="tps_cpf_cnpj">
                <the-mask
                    v-model="pessoa.tps_cpf_cnpj"
                    class="form-control"
                    id="tps_cpf_cnpj"
                    v-on:focusout.native="locSocio(pessoa.tps_cpf_cnpj)"
                    :class="{ 'is-invalid': $v.pessoa.tps_cpf_cnpj.$error }"
                    :mask="['###.###.###-##', '##.###.###/####-##']"/>
                <div v-if="$v.pessoa.tps_cpf_cnpj.$error" class="invalid-feedback">
                  Informe CPF ou CNPJ
                </div>
              </b-form-group>
            </div>
            <div class="col-md-8">
              <b-form-group label="Nome Completo" label-for="tps_razao_social_nome">
                <input class="form-control" v-model="pessoa.tps_razao_social_nome"
                       :class="{ 'is-invalid': $v.pessoa.tps_razao_social_nome.$error }"
                       id="tps_razao_social_nome" type="text">
                <div v-if="$v.pessoa.tps_razao_social_nome.$error" class="invalid-feedback">
                  Informe seu nome completo ou razão social
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="E-mail" label-for="tps_mail">
                <input class="form-control" v-model="pessoa.tps_mail"
                       :class="{ 'is-invalid': $v.pessoa.tps_mail.$error }"
                       ref="tps_mail"
                       id="tps_mail" type="email">
                <div v-if="$v.pessoa.tps_mail.$error" class="invalid-feedback">
                  Informe o e-mail
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Celular" label-for="tet_codigo_celular">
                <input class="form-control" v-model="pessoa.tet_codigo_celular"
                       v-mask="'(##) ##### - ####'"
                       ref="tet_codigo_celular"
                       id="tet_codigo_celular" type="text">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Tel. Comercial" label-for="tet_codigo_comercial">
                <input class="form-control" v-model="pessoa.tet_codigo_comercial"
                       v-mask="'(##) #### - ####?#'"
                       :class="{ 'is-invalid': $v.pessoa.tet_codigo_comercial.$error }"
                       id="tet_codigo_comercial" type="text">
                <div v-if="$v.pessoa.tet_codigo_comercial.$error" class="invalid-feedback">
                  Informe um telefone comercial
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <b-form ref="formEnd">
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group
                        id="cep-group"
                        label="CEP"
                        label-for="cep-reply">
                      <input
                          id="cep-reply"
                          ref="ted_cep"
                          v-model="pessoa.ted_cep"
                          v-on:focusout="locCEP(pessoa.ted_cep)"
                          v-mask="'##.###-###'"
                          type="text"
                          maxlength="20"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': errorCep || (submitted && $v.pessoa.ted_cep.$error)}">
                      <div v-show="$v.pessoa.ted_cep.$error" class="invalid-feedback">
                        Informe um CEP
                      </div>
                      <div v-show="errorCep" class="invalid-feedback">
                        CEP não encontrado
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                        id="cidade-group"
                        label="Cidade - UF"
                        label-for="cidade">
                      <h5 v-if="pessoa.mun_nome" class="mb-3 mt-3">{{ pessoa.mun_nome }} -
                        {{ pessoa.mun_uf }}</h5>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                        id="quadra-group"
                        label="Endereço/Quadra"
                        label-for="quadra">
                      <input
                          id="quadra"
                          ref="ted_logradouro"
                          v-model="pessoa.ted_logradouro"
                          type="text"
                          maxlength="200"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': submitted && $v.pessoa.ted_logradouro.$error,}">
                      <div v-show="$v.pessoa.ted_logradouro.$error" class="invalid-feedback">
                        Informe seu endereço
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group
                        id="lote-group"
                        label="Número/Lote"
                        label-for="lote">
                      <input
                          id="lote"
                          ref="ted_numero"
                          v-model="pessoa.ted_numero"
                          type="text"
                          maxlength="10"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': submitted && $v.pessoa.ted_numero.$error,}">
                      <div v-show="$v.pessoa.ted_numero.$error" class="invalid-feedback">
                        Seu Número
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-5">
                    <b-form-group
                        id="bairro-group"
                        label="Bairro"
                        label-for="cep-reply">
                      <input
                          id="bairro"
                          v-model="pessoa.ted_bairro"
                          type="text"
                          maxlength="100"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': submitted && $v.pessoa.ted_bairro.$error,}">
                      <div v-show="$v.pessoa.ted_bairro.$error" class="invalid-feedback">
                        Informe o bairro
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                        id="complemento-group"
                        label="Complemento"
                        label-for="complemento">
                      <input
                          id="complemento"
                          v-model="pessoa.ted_complemento"
                          type="text"
                          maxlength="100"
                          class="form-control"
                          placeholder=" ">
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                        id="group-ted_ponto_referencia"
                        label="Ponto de Referência"
                        label-for="ted_ponto_referencia">
                      <input
                          id="ted_ponto_referencia"
                          v-model="pessoa.ted_ponto_referencia"
                          type="text"
                          maxlength="100"
                          class="form-control"
                          placeholder=" ">
                    </b-form-group>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </Loader>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <b-button variant="success" @click="saveTabeliao">
          {{ pessoa.tps_codigo ? 'Atualizar tabelião' : 'Incluir tabelião' }}
        </b-button>
        <b-button variant="danger" @click="closeModal('modal-new-tabeliao')">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </Loader>
</template>
<script>
import {TheMask} from 'vue-the-mask'
import {required} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader"
import {getCEP} from "@/api/externa/cep"
import {getSocio} from "@/api/core/pessoa";
import {setCecSetTabeliao, deleteCecSetTabeliao} from "@/api/solicitacao/pessoa";
import Swal from "sweetalert2";

export default {
  components: {
    Loader,
    TheMask
  },
  props: {
    list_socio: {
      type: Array,
    },
    ecomonico: {
      type: Object,
    },
    tabeliao: {
      type: Object,
    }
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '%',
        precision: 2
      },
      pessoa: this.pessoaReset(),
      socios: [],
      errorCep: false,
      submitted: false,
      httpSend: false
    };
  },
  validations: {
    pessoa: {
      tps_cpf_cnpj: {
        required
      },
      tps_razao_social_nome: {
        required,
      },
      tet_codigo_comercial: {
        required,
      },
      tps_mail: {
        required,
      },
      ted_tipo: {
        required
      },
      ted_cep: {
        required
      },
      ted_bairro: {
        required,
      },
      ted_numero: {
        required,
      },
      ted_logradouro: {
        required,
      },
    },
  },
  methods: {
    pessoaReset() {
      return {
        pes_codigo: null,
        tps_codigo: null,
        ted_codigo: null,
        tps_cpf_cnpj: "",
        tps_razao_social_nome: "",
        tet_codigo_celular: "",
        tet_codigo_comercial: "",
        tps_mail: "",
        tms_qualificacao: "",
        tms_participacao: 0.00,
        tms_representante: false,
        ted_tipo: "907",
        ted_cep: "",
        ted_logradouro: "",
        ted_bairro: "",
        ted_numero: "",
        ted_complemento: "",
        ted_ponto_referencia: "",
        mun_codigo: null,
        mun_uf: "",
        mun_nome: "",
      }
    },
    resetAll() {
      this.pessoa = this.pessoaReset();
    },
    locSocio(cpfcnpj) {
      if (!cpfcnpj) {
        return
      }
      this.httpSend = true;
      getSocio({pes_cpfcnpj: cpfcnpj}).then(result => {
        this.pessoa.pes_codigo = null;
        this.pessoa.tps_codigo = null;
        this.pessoa.tps_razao_social_nome = null;
        this.pessoa.tps_mail = null;
        if (result.status) {
          if (result.dados.pes_codigo) {
            this.pessoa.pes_codigo = result.dados.pes_codigo
          }
          if (result.dados.tps_codigo) {
            this.pessoa.tps_codigo = result.dados.tps_codigo
          }
          this.pessoa.tps_razao_social_nome = result.dados.nome
          this.pessoa.tps_mail = result.dados.mail;
          if (this.pessoa.tps_mail) {
            this.$refs.tet_codigo_celular.focus();
          } else {
            this.$refs.tps_mail.focus();
          }
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    locCEP(cep) {
      if (!cep) {
        return
      }
      this.httpSend = true;
      this.errorCep = false;
      getCEP(cep).then(result => {
        if (result.status === 200) {
          if (Object.prototype.hasOwnProperty.call(result.data, 'erro')) {
            this.$refs.ted_cep.focus();
            this.errorCep = true;
            this.pessoa.mun_uf = '';
            this.pessoa.mun_nome = '';
            this.pessoa.mun_codigo = null;
            this.pessoa.ted_bairro = '';
            this.pessoa.ted_logradouro = '';
          } else {
            this.errorCep = false;
            this.pessoa.mun_uf = result.data.uf;
            this.pessoa.mun_nome = result.data.localidade;
            this.pessoa.mun_codigo = result.data.ibge;
            this.pessoa.ted_bairro = result.data.bairro;
            this.pessoa.ted_logradouro = result.data.logradouro;
            if (this.pessoa.ted_logradouro) {
              this.$refs.ted_numero.focus();
            } else {
              this.$refs.ted_logradouro.focus()
            }
          }
        }
      }).catch(error => {
        console.log(error)
        this.errorCep = false;
      }).finally(() => {
        this.httpSend = false
      })
    },
    saveTabeliao() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.pessoa.$invalid) {
        return;
      }
      this.httpSend = true;
      setCecSetTabeliao({ecomonico: this.ecomonico, tabeliao: this.pessoa}).then(response => {
        if (response.status) {
          const tabeliao = response.dados.tabeliao;
          response.dados.telefone.forEach(function (t) {
            if (t.tet_codigo.tab_numero === 1) {
              tabeliao.tet_codigo_celular = t.tfo_numero;
              tabeliao.tfo_codigo_celular = t.tfo_codigo;
            }
            if (t.tet_codigo.tab_numero === 2) {
              tabeliao.tet_codigo_comercial = t.tfo_numero;
              tabeliao.tfo_codigo_comercial = t.tfo_codigo;
            }
          });
          this.$emit('update:tabeliao', tabeliao);
          this.$refs['modal-new-tabeliao'].hide();
          this.resetAll();
          this.submitted = false;
        } else {
          this.$toast.error(response.mensagem);
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    openTabeliao(socio) {
      this.pessoa = socio;
      this.$refs['modal-new-tabeliao'].show();
    },
    closeModal(ref) {
      this.$refs[ref].hide();
      this.resetAll();
    },
    deleteTabeliao(tabeliao) {
      Swal.fire({
        title: "Excluir tabelião?",
        html: `Deseja realmente excluir o tabelião <b>${tabeliao.tps_razao_social_nome}</b>`,
        text: ``,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f47a78",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.httpSend = true;
          deleteCecSetTabeliao(tabeliao.tec_codigo).then(response => {
            if (response.status) {
              this.$emit('update:tabeliao', {});
            } else {
              this.$toast.error(response.mensagem);
            }
          }).catch(error => {
            console.log(error)
          }).finally(() => {
            this.httpSend = false
          })
        } else {
          return false;
        }
      });
    },
  },

};
</script>